import React, { createContext, useContext, useState } from 'react';

const DueDateContext = createContext();

export const useDueDate = () => useContext(DueDateContext);

export const DueDateProvider = ({ children }) => {
	const [dueDateStatus, setDueDateStatus] = useState(null);
	const [remainingDays, setRemainingDays] = useState(null);
	const [reqStatus, setReqStatus] = useState(null);

	return (
		<DueDateContext.Provider
			value={{
				dueDateStatus,
				setDueDateStatus,
				remainingDays,
				setRemainingDays,
				reqStatus,
				setReqStatus,
			}}>
			{children}
		</DueDateContext.Provider>
	);
};
